import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import { injectIntl } from 'react-intl'

import locales from '../utility/locales'
import pages from '../utility/pages'

// Devono iniziare con /, non essere seguiti da /, e nemmeno da numeri di 4 cifre (/2018)
const INTERNAL_REGEX = new RegExp(`^/(?!/)(?![0-9]{4})`);

const LocalizedLink = ({ to, title, literal = false, intl: { locale, formatMessage, messages }, children, ...props }) => {
  const internal = INTERNAL_REGEX.test(to);
  if (!internal) {
    // Remove activeClassName prop from external links
    const { activeClassName, ...other } = props;
    return (
      <a href={to} title={title} {...other}>
        <>
          {children}
        </>
      </a>
    );
  }
  if (literal) {
    return (
      <GatsbyLink to={to} title={title} {...props}>
        <>
          {children}
        </>
      </GatsbyLink>
    );
  }
  let path = to;
  let localizedTo;
  // Gestione hash link
  if (to.includes('#')) {
    let route = to.substring(0, to.indexOf('#'));
    if (pages[locale](route)) {
      localizedTo = `${pages[locale](route)}${to.substring(to.indexOf('#'))}`;
    } else {
      localizedTo = to;
    }
  } else {
    localizedTo = pages[locale](to) || to;
  }

  if (!locales[locale].default && localizedTo) {
    if (localizedTo.startsWith(`/${locales[locale].path}/`)) {
      console.warn(`Trovato path localizzato con prefisso locale già presente ${localizedTo}(da ${to}): dovrebbe essere rimosso`);
      path = `/${localizedTo}`;
    } else {
      path = `/${locale}${localizedTo}`;
    }
  }

  // Traduci il titolo se c'è e se esiste una traduzione, altrimenti lascialo com'è senza warning
  const translatedTitle = title ? (messages[title] ? formatMessage({ id: title }) : title) : undefined;

  const { className, activeClassName, style, activeStyle } = props;

  // Gestione activeClassName indipendente da slash finale o meno
  const isActive = ({ isPartiallyCurrent, href, location}) => {
    if (isPartiallyCurrent){
      const pathname = location.pathname;
      const strippedHref = href.endsWith('/') ? href.substring(0, href.length-1) : href;
      const strippedPathname = pathname.endsWith('/') ? pathname.substring(0, pathname.length-1) : pathname;
      if (strippedHref === strippedPathname){
        return { 
          className: [className, activeClassName].filter(Boolean).join(" "), 
          style: {...style, ...activeStyle}
        };
      }
    }
    return null;
  }

  return (
    <GatsbyLink getProps={isActive} to={path} title={translatedTitle} {...props}>
      <>
        {children}
      </>
    </GatsbyLink>
  );
}

export const Link = injectIntl(LocalizedLink);